import { useEffect, useMemo, type ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { useAppSelector } from '@/store/hooks';
import { buildAntdTheme } from '@/theme/antdTheme';
import { applyThemeVars } from '@/theme/cssVars';

/**
 * Provides the AntD theme + `--ol-*` CSS variables above the whole tree — including the auth gate, so
 * the hub-login screen is themed. Hoisted out of App so it wraps OneLatticeAuthProvider (main.tsx).
 */
export function ThemedRoot({ children }: { children: ReactNode }) {
  const theme = useAppSelector((s) => s.ui.theme);

  useEffect(() => {
    applyThemeVars(theme);
  }, [theme]);

  const antdTheme = useMemo(() => buildAntdTheme(theme), [theme]);

  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
}
